<template>
  <div class="headerTitle">
    <div class="headertitle">
      <div class="blue"></div>
      <span class="">{{ title }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "headerTitle",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.headerTitle {
  width: calc(100% - 0px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(112, 112, 112, 0.2);
  .headertitle {
    height: 20px;
    padding-bottom: 5px;
    span {
      vertical-align: top;
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      color: #333333;
    }
  }
  .blue {
    display: inline-block;
    width: 4px;
    height: 100%;
    background: #416eff;
    margin-right: 10px;
  }
}
</style>
